import { useMemo, useState } from "react";
import { mixedFeed } from "@/mocks/homeData";
import { SectionHead, TagPill } from "./kit";

const filterCats = ["全部", "招商", "消费", "职场", "直播", "行业", "教育", "品牌"];

export default function MixedFeed() {
  const [cat, setCat] = useState("全部");

  const items = useMemo(
    () => (cat === "全部" ? mixedFeed : mixedFeed.filter((f) => f.category === cat)),
    [cat],
  );

  return (
    <section id="feed" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-7 md:px-6 md:py-10">
        <SectionHead
          kicker="INVESTIGATION · 图文并重"
          title="深度长文 · 把来龙去脉讲透"
          tone="primary"
        />

        {/* category filter */}
        <div className="no-scrollbar mb-6 flex gap-2 overflow-x-auto pb-1">
          {filterCats.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCat(c)}
              className={`shrink-0 cursor-pointer rounded-full px-3.5 py-1.5 text-sm whitespace-nowrap transition-colors ${
                cat === c
                  ? "bg-foreground-950 font-semibold text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-600 hover:border-foreground-400"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* mixed grid */}
        <div className="columns-1 gap-5 sm:columns-2 lg:columns-3">
          {items.map((f) => (
            <article
              key={f.id}
              className="group mb-5 break-inside-avoid cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className={`relative w-full overflow-hidden ${f.big ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
                <img
                  src={f.img}
                  alt={f.title}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/35 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
                <span className="absolute left-3 top-3">
                  <TagPill tone={f.tone}>{f.category}</TagPill>
                </span>
                {f.big && (
                  <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-600 px-2.5 py-1 text-[11px] font-bold text-background-50">
                    <i className="ri-fire-fill" />
                    深度报告
                  </span>
                )}
              </div>
              <div className="flex flex-col gap-2 p-4 md:p-5">
                <h3
                  className={`font-heading font-bold leading-snug text-foreground-950 transition-colors group-hover:text-accent-800 ${
                    f.big ? "text-lg md:text-xl" : "text-[15px]"
                  }`}
                >
                  {f.title}
                </h3>
                <p className="line-clamp-2 text-[13px] leading-relaxed text-foreground-600">{f.excerpt}</p>
                <div className="mt-1 flex flex-wrap items-center justify-between gap-2 border-t border-background-200 pt-3 text-[11px] text-foreground-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-file-paper-2-line text-secondary-700" />
                    {f.meta}
                  </span>
                  <span className="inline-flex items-center gap-2">
                    <span className="text-foreground-500">{f.time}</span>
                    <span className="rounded bg-background-100 px-1.5 py-0.5 text-foreground-500">读{f.read}</span>
                    <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-accent-600" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-4 flex justify-center">
          <button
            type="button"
            className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-semibold text-foreground-800 whitespace-nowrap transition-colors hover:border-accent-300 hover:text-accent-700"
          >
            加载更多档案
            <i className="ri-arrow-down-s-line" />
          </button>
        </div>
      </div>
    </section>
  );
}